/* piolet-clickid-capture.js — ATTR_GAPS_FIX 2026-09-08; eager (not text/lazyload)
   2026-10-19: _wa_token from piolet_wa_token_v1 (minted even if WhatsApp never opens);
   _fbc is fb.1.<ms>.<fbclid> when the _fbc cookie is missing. */
(function() {
    var KEYS = ['gclid','gbraid','wbraid','fbclid','utm_source','utm_medium','utm_campaign','utm_campaign_name','utm_content','utm_term','fbc','fbp'];
    var ATTR_MAP = {
      gclid: '_gclid',
      gbraid: '_gbraid',
      wbraid: '_wbraid',
      fbclid: '_fbclid',
      utm_source: '_utm_source',
      utm_medium: '_utm_medium',
      utm_campaign: '_utm_campaign',
      utm_campaign_name: '_utm_campaign_name',
      utm_content: '_utm_content',
      utm_term: '_utm_term',
      fbc: '_fbc',
      fbp: '_fbp',
      wa_token: '_wa_token'
    };
    var WA_TOKEN_KEY = 'piolet_wa_token_v1';
    var WA_TOKEN_MS = 90 * 864e5;

    function readCookie(name) {
      try {
        var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
        return m ? decodeURIComponent(m[1]) : '';
      } catch (e) { return ''; }
    }

    function fbcMatches(fbc, fbclid) {
      if (!fbc || !fbclid || fbc.indexOf('fb.1.') !== 0) return false;
      var tail = '.' + fbclid;
      return fbc.slice(-tail.length) === tail;
    }

    function stampFbc(ids, persist) {
      if (!ids || readCookie('_fbc') || !ids.fbclid) return ids;
      if (ids.fbc && fbcMatches(ids.fbc, ids.fbclid)) return ids;
      ids.fbc = 'fb.1.' + Date.now() + '.' + ids.fbclid;
      if (persist) {
        try { localStorage.setItem('piolet_clickids', JSON.stringify(ids)); } catch (e) {}
      }
      return ids;
    }

    function ensureWaToken() {
      var now = Date.now();
      try {
        var saved = JSON.parse(localStorage.getItem(WA_TOKEN_KEY) || 'null');
        if (saved && typeof saved.t === 'string' && /^[a-z0-9]{8}$/.test(saved.t) && (now - saved.ts) < WA_TOKEN_MS) return saved.t;
      } catch (e) {}
      var alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789', t = '';
      for (var i = 0; i < 8; i++) t += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
      try { localStorage.setItem(WA_TOKEN_KEY, JSON.stringify({ t: t, ts: now })); } catch (e2) {}
      return t;
    }

    function readStored() {
      try {
        var stored = localStorage.getItem('piolet_clickids');
        if (!stored) return null;
        var data = JSON.parse(stored);
        if (Date.now() - (data._ts || 0) > 90*24*3600*1000) {
          localStorage.removeItem('piolet_clickids');
          return null;
        }
        return data;
      } catch (e) { return null; }
    }

    function mergeFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        var ids = {};
        KEYS.forEach(function(k) {
          var v = params.get(k);
          if (v) ids[k] = v;
        });
        // Meta browser cookies (not always in URL)
        var cookieFbc = readCookie('_fbc');
        var cookieFbp = readCookie('_fbp');
        if (cookieFbc) ids.fbc = cookieFbc;
        if (cookieFbp) ids.fbp = cookieFbp;
        // If only cookies (no URL params) still persist
        if (!Object.keys(ids).length) return stampFbc(readStored(), true);
        try {
          var prev = JSON.parse(localStorage.getItem('piolet_clickids') || '{}');
          if (prev && prev._ts && (Date.now() - prev._ts) <= 90*24*3600*1000) {
            KEYS.forEach(function(k) {
              if (prev[k] && !ids[k]) ids[k] = prev[k];
            });
            if (prev._ts) ids._ts = prev._ts;
          }
        } catch (eMerge) {}
        stampFbc(ids, false);
        if (!ids._ts) ids._ts = Date.now();
        localStorage.setItem('piolet_clickids', JSON.stringify(ids));
        return ids;
      } catch (e) { return stampFbc(readStored(), true); }
    }

    function buildAttrs(data) {
      var attrs = {};
      if (!data) return attrs;
      Object.keys(ATTR_MAP).forEach(function(k) {
        if (data[k]) attrs[ATTR_MAP[k]] = String(data[k]);
      });
      return attrs;
    }

    window.pioletApplyClickIds = function(force) {
      return new Promise(function(resolve) {
        try {
          var data = mergeFromUrl() || readStored();
          if (!data) data = {};
          data.wa_token = ensureWaToken();
          if (!data.wa_token) { resolve(false); return; }
          var stored = JSON.stringify(data);
          if (!force && sessionStorage.getItem('piolet_clickids_synced') === stored) {
            resolve(true); return;
          }
          var attrs = buildAttrs(data);
          if (!Object.keys(attrs).length) { resolve(false); return; }
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ attributes: attrs })
          }).then(function(r) {
            if (r.ok) sessionStorage.setItem('piolet_clickids_synced', stored);
            resolve(!!r.ok);
          }).catch(function(){ resolve(false); });
        } catch (e) { resolve(false); }
      });
    };

    function isCheckoutTrigger(el) {
      if (!el || !el.closest) return null;
      return el.closest(
        'shop-pay-wallet-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart,' +
        'button[name="checkout"], [name="checkout"],' +
        'a[href*="/checkout"], button[href*="/checkout"],' +
        '[data-shopify-accelerated-checkout], .shopify-payment-button, .dynamic-checkout__content button, .dynamic-checkout__content a'
      );
    }

    // Early sync on pointerdown (no preventDefault — Shop Pay custom elements break if we block click)
    document.addEventListener('pointerdown', function(ev) {
      if (!isCheckoutTrigger(ev.target)) return;
      window.pioletApplyClickIds(true);
    }, true);
    document.addEventListener('click', function(ev) {
      if (!isCheckoutTrigger(ev.target)) return;
      window.pioletApplyClickIds(true);
    }, true);
    // keepalive last chance when leaving to checkout/Shop Pay
    window.addEventListener('pagehide', function() {
      try {
        var data = null;
        try { data = JSON.parse(localStorage.getItem('piolet_clickids') || 'null'); } catch (e) {}
        if (!data) return;
        var attrs = {};
        Object.keys(ATTR_MAP).forEach(function(k){ if (data[k]) attrs[ATTR_MAP[k]] = String(data[k]); });
        var waTok = ensureWaToken();
        if (waTok) attrs._wa_token = waTok;
        if (!Object.keys(attrs).length) return;
        if (navigator.sendBeacon) {
          navigator.sendBeacon('/cart/update.js', new Blob([JSON.stringify({ attributes: attrs })], { type: 'application/json' }));
        }
      } catch (e3) {}
    });

    // Also sync on add-to-cart / pageshow
    document.addEventListener('pageshow', function(){ window.pioletApplyClickIds(false); });
    document.addEventListener('piolet:cart:changed', function(){ window.pioletApplyClickIds(true); });

    // always auto-run; PDP cart-clear also force-applies
    window.pioletApplyClickIds(false);
  
    function boot(){ try { window.pioletApplyClickIds(false); } catch(e){} }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();
